// extracted by mini-css-extract-plugin
export default {"container":"bZ-z","title":"cZ-z","link":"dZ-z"};